import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-details-page-loading-overlay',
  templateUrl: './details-page-loading-overlay.component.html',
  styleUrls: ['./details-page-loading-overlay.component.scss']
})
export class DetailsPageLoadingOverlayComponent {
  @Input()
  showMenu = false;

  @Input()
  showHeader = true;

  constructor(

  ) { }


}
